import { z } from "zod";
/**
 * Строки view взаиморасчётов (контракт v2.0 §4.2, CCR-029…034) и ответы RPC `corp_payment_*`,
 * `corp_adjustment_create`, `corp_order_adjust`, `corp_generate_invoices`, `corp_invoice_*` (§4.3).
 */
/** `v_corp_invoices`; у VOID `paid_amount`/`payment_state` = null (CCR-033). */
export const zCorpInvoiceRowDto = z.object({
    invoice_id: z.string(),
    company_id: z.string(),
    number: z.string(),
    period_start: z.string(),
    period_end: z.string(),
    issue_date: z.string(),
    due_date: z.string(),
    total: z.number(),
    orders_count: z.number(),
    total_kwh: z.number(),
    status: z.string(),
    external_doc_number: z.string().nullish(),
    external_doc_date: z.string().nullish(),
    paid_amount: z.number().nullable(),
    payment_state: z.string().nullable(),
    is_overdue: z.boolean(),
    days_overdue: z.number().nullish(),
    run_id: z.string().nullish(),
    voided_at: z.string().nullish(),
    voided_by: z.string().nullish(),
    void_reason: z.string().nullish(),
});
export const CORP_INVOICE_COLUMNS = "invoice_id,company_id,number,period_start,period_end,issue_date,due_date,total,orders_count,total_kwh,status,external_doc_number,external_doc_date,paid_amount,payment_state,is_overdue,days_overdue,run_id,voided_at,voided_by,void_reason";
/** `v_corp_invoice_lines`. */
export const zCorpInvoiceLineRowDto = z.object({
    line_id: z.string(),
    invoice_id: z.string(),
    company_id: z.string(),
    /** Строка без заказа (корректировка в счёте): order_id/kwh/цена/сбор = null — сверено с TEST (INV-000022). */
    order_id: z.string().nullish(),
    order_number: z.string().nullish(),
    line_date: z.string(),
    description: z.string().nullish(),
    employee_label: z.string().nullish(),
    kwh: z.number().nullish(),
    price_per_kwh: z.number().nullish(),
    service_fee: z.number().nullish(),
    amount: z.number(),
});
/** `v_corp_payments`. */
export const zCorpPaymentRowDto = z.object({
    payment_id: z.string(),
    company_id: z.string(),
    amount: z.number(),
    paid_at: z.string(),
    doc_number: z.string().nullish(),
    doc_date: z.string().nullish(),
    comment: z.string().nullish(),
    is_voided: z.boolean(),
    voided_at: z.string().nullish(),
    created_at: z.string(),
    created_by: z.string().nullish(),
    voided_by: z.string().nullish(),
    void_reason: z.string().nullish(),
});
/**
 * `v_corp_ledger`. Читать `select("*")`, чтобы новые колонки WP-DB-05 подхватились без правки; лишние
 * ключи Zod игнорирует. `reverses_entry_id`/`created_by_kind` — опциональны до WP-DB-05 (CCR-029).
 */
export const zCorpLedgerRowDto = z.object({
    entry_id: z.string(),
    company_id: z.string(),
    entry_type: z.string(),
    entry_class: z.string(),
    amount: z.number(),
    effective_at: z.string(),
    description: z.string().nullish(),
    order_id: z.string().nullish(),
    order_number: z.string().nullish(),
    payment_id: z.string().nullish(),
    invoice_id: z.string().nullish(),
    invoice_number: z.string().nullish(),
    created_at: z.string(),
    created_by: z.string().nullish(),
    reverses_entry_id: z.string().nullish(),
    created_by_kind: z.string().nullish(),
});
export const CORP_LEDGER_COLUMNS = "*";
/** Ответ `corp_payment_register` (§4.3). */
export const zPaymentRegisterResultDto = z.object({
    paymentId: z.string(),
    ledgerEntryId: z.string(),
    balance: z.number(),
});
/** Ответ `corp_payment_void` (§4.3). */
export const zPaymentVoidResultDto = z.object({
    paymentId: z.string(),
    reversalEntryId: z.string(),
    balance: z.number(),
});
/** Ответ `corp_adjustment_create` (§4.3). */
export const zAdjustmentResultDto = z.object({
    ledgerEntryId: z.string(),
    balance: z.number(),
});
/** Ответ `corp_order_adjust` (§4.3). */
export const zOrderAdjustResultDto = z.object({
    orderId: z.string(),
    oldAmount: z.number(),
    newAmount: z.number(),
    balance: z.number(),
});
/** Элемент `invoicesCreated` ответа `corp_generate_invoices` (§4.3). */
export const zBillingRunInvoiceDto = z.object({
    invoiceId: z.string(),
    number: z.string(),
    companyId: z.string(),
    periodStart: z.string(),
    periodEnd: z.string(),
    total: z.number(),
});
/** Ответ `corp_generate_invoices` (§4.3). */
export const zBillingRunResultDto = z.object({
    runId: z.string(),
    asOf: z.string(),
    companiesChecked: z.number(),
    invoicesCreated: z.array(zBillingRunInvoiceDto),
});
/** Ответ `corp_invoice_void` (§4.3). */
export const zInvoiceVoidResultDto = z.object({
    invoiceId: z.string(),
    status: z.string(),
});
/** Ответ `corp_invoice_set_external_doc` (§4.3). */
export const zInvoiceExternalDocResultDto = z.object({
    invoiceId: z.string(),
});
